<template>
  <div>
      {{sLabel ==='' ? `Tabla` : sLabel}}
  </div>
</template>

<script>
import mixin from '@/mixins/BuildCorreoComponentes.js'
  export default {
    name:"Tabla",
    mixins:[mixin],
    data() {
      return {
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>